import { render, staticRenderFns } from "./privacy-policies-layout.vue?vue&type=template&id=5ad63282"
import script from "./privacy-policies-layout.vue?vue&type=script&lang=js"
export * from "./privacy-policies-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports